import React, { useEffect, useRef, useState } from 'react'
import styles from './Inquire.module.scss'
import Content from '../../components/content/Content'
import Footer from '../../components/footer/Footer'
import Modal from '../../components/modal/Modal'
import UseModal from '../../hooks/UseModal'
import { UseApi } from '../../hooks/UseApi';
import { apiList } from '../../ApiList';
import { AxiosError } from 'axios'
import { DdokddokResponse } from '../../types/Types'

const AgreeInfoModal = ({onClick} : {onClick:()=>void}) => {
    const confirm = (e:React.MouseEvent) => {
        onClick()
        e.stopPropagation()
    }
    return (
        <Modal onClickToggleModal={onClick} width={616} background = {true} radius = {true}>
                <div className={`body1 extrabold`}>개인정보 수집 및 이용 안내 동의</div>
                <div className={`body2 extrabold mgt24`}>수집·이용 목적</div>
                <div className={`body3 medium`}>문의내용 확인 및 답변을 위해 수집·이용됨</div>
                <div className={`body2 extrabold mgt16`}>수집항목</div>
                <div className={`body3 medium`}>이름, 업체명, 이메일, 연락처</div>
                <div className={`body2 extrabold mgt16`}>보유 및 이용 기간</div>
                <div className={`body3 medium`}>3년간 보유 및 이용 이후 파기</div>
                <div className={`body2 extrabold mgt16`}>동의거부 권리알림</div>
                <div className={`body3 medium`}> 개인정보 수집·이용에 대하여 동의를 거부할 수 있으며, 동의를 하지 않으면 서비스 관련 문의를 할 수 없습니다.</div>
                <div className={`${styles.agree_modal_button} mgt24`} onClick={confirm}>확인</div>
        </Modal>
    )
}

const AlertModal = ({onClick} : {onClick:()=>void}) => {
    const confirm = (e:React.MouseEvent) => {
        onClick()
        e.stopPropagation()
    }
    return (
        <Modal onClickToggleModal={onClick} width={616} background = {true} radius = {true} >
            <div className='body1 medium'>개인정보처리 방침에 동의해야 문의할 수 있습니다.</div>
            <div className={`${styles.agree_modal_button} mgt24`} onClick={confirm}>확인</div>
        </Modal>
    )
}

const ResultModal = ({isSuccess, onClick} : {isSuccess: boolean, onClick:()=>void}) => {
    const success = "문의에 성공 하였습니다.";
    const fail = "문의에 실패 하였습니다.";

    const confirm = (e:React.MouseEvent) => {
        onClick()
        e.stopPropagation()
        if(isSuccess){
            window.location.reload();
        }
    }

    return (
        <Modal onClickToggleModal={onClick} width={616} background = {true} radius = {true} >
            <div className='body1 medium'>{isSuccess ? success : fail}</div>
            <div className={`${styles.agree_modal_button} mgt24`} onClick={confirm}>확인</div>
        </Modal>
    )
}

const Inquire = () => {
    const [inputName, setInputName] = useState('');
    const [inputCorpName, setInputCorpName] = useState('');
    const [inputEmail, setInputEmail] = useState('');
    const [inputTel, setInputTel] = useState('');
    const [inputInquire, setInputInquireContent] = useState('');
    const [checkAgree, setCheckAgree] = useState(false);
    const [resultInquire, setResultInquire] = useState(false);

    const agreeInfoModal = UseModal();
    const alertModal = UseModal();
    const resultModal = UseModal();

    const inquireRequestAPI = UseApi({ method: 'post', url : apiList.inquire, apiName: "inquire", body: {name: inputName, corpName: inputCorpName, email: inputEmail, tel: inputTel, etc: inputInquire}, time : false, async: false, focus: true });

    useEffect(()=>{
        if( !inquireRequestAPI.isLoading && inquireRequestAPI.error ) {
            const { response }= inquireRequestAPI.error as AxiosError;
            const data = response?.data as DdokddokResponse;
            resultModal.onClickToggleModal();
            setResultInquire(false);

        } else if( !inquireRequestAPI.isLoading && inquireRequestAPI.data) {
            const response = inquireRequestAPI.data;
            resultModal.onClickToggleModal();
            setResultInquire(true);
        }

    },[inquireRequestAPI.isLoading, inquireRequestAPI.data])

    const handelName = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.currentTarget.classList.remove(styles.empty_input);
        setInputName(event.currentTarget.value);
    }
    const handelCorpName = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.currentTarget.classList.remove(styles.empty_input);
        setInputCorpName(event.currentTarget.value);
    }
    const handelEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
        const reg = /^[a-zA-Z0-9+-\_.]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
        event.currentTarget.classList.add(styles.empty_input);

        if(reg.test(event.currentTarget.value)){
            event.currentTarget.classList.remove(styles.empty_input);
            setInputEmail(event.currentTarget.value);
        }
        
    }
    const handelTel = (event: React.ChangeEvent<HTMLInputElement>) => {
        const reg = /^[0-9\b]{0,15}$/;
        if(isNaN(Number(event.currentTarget.value)) && event.currentTarget.value.length <= 15 ) {
            event.currentTarget.classList.add(styles.empty_input);
        }
        if(reg.test(event.currentTarget.value) || event.currentTarget.value.length === 0) {
            event.currentTarget.classList.remove(styles.empty_input);
            setInputTel(event.currentTarget.value);
        }
    }

    const handelInquireContent = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        if (e.target.value.length > 1000) return;
        setInputInquireContent(e.target.value);
    };


    const submit = () =>{
        if (inputName.length === 0) {
            const input = document.getElementById('name') as HTMLInputElement;
            input.classList.add(styles.empty_input);
            input.focus();
            return;
        }
        if (inputCorpName.length === 0) {
            const input = document.getElementById('corpName') as HTMLInputElement;
            input.classList.add(styles.empty_input);
            input.focus();
            return;
        }
        if (inputEmail.length === 0) {
            const input = document.getElementById('email') as HTMLInputElement;
            input.classList.add(styles.empty_input);
            input.focus();
            return;
        }
        if (inputTel.length === 0) {
            const input = document.getElementById('tel') as HTMLInputElement;
            input.classList.add(styles.empty_input);
            input.focus();
            return;
        }
        if(!checkAgree) {
            alertModal.onClickToggleModal()
            return;
        }
        inquireRequestAPI.refetch();
    }

    return (
        <div >
            {agreeInfoModal.isOpenModal && <AgreeInfoModal onClick={agreeInfoModal.onClickToggleModal}/>}
            {alertModal.isOpenModal && <AlertModal onClick={alertModal.onClickToggleModal}/>}
            {resultModal.isOpenModal && <ResultModal isSuccess={resultInquire} onClick={resultModal.onClickToggleModal}/>}

            <Content>
                <div className={styles.bg}>
                    <form className={styles.form_box} method="post">
                        <div className={`${styles.title} H3 bold gs10`}>도입 문의하기</div>
                        <div className={`${styles.two_colum} mgt40`}>
                            <div>
                                <label htmlFor="name" className='body3 medium gs7'>이름<span className='body3 medium sub7'>*</span></label>
                                <input type="text" id="name"  className='body3 medium' placeholder='이름 입력' onChange={handelName} />
                            </div>
                            <div>
                                <label htmlFor="corpName" className='body3 medium gs7'>업체명<span className='body3 medium sub7'>*</span></label>
                                <input type="text" id="corpName" className='body3 medium' placeholder='업체명 입력'  onChange={handelCorpName} />
                            </div>
                        </div>
                        <div className={styles.two_colum}>
                            <div>
                                <label htmlFor="email" className='body3 medium gs7'>연락 받으실 이메일<span className='body3 medium sub7'>*</span></label>
                                <input type="text" id="email" className='body3 medium' placeholder='ex) admin@ddokddok2.com' onChange={handelEmail} />
                            </div>
                            <div>
                                <label htmlFor="tel" className='body3 medium gs7'>연락 받으실 연락처<span className='body3 medium sub7'>*</span></label>
                                <input type="text" pattern="[0-9]+" id="tel" className='body3 medium' placeholder='ex) 01012345678' onChange={handelTel} value={inputTel} />
                            </div>
                        </div>
                        <div className={styles.etc}>
                            <div className={`${styles.etc_title} body3 medium gs7`}>
                                <label htmlFor="etc" >기타 문의 시 입력해 주세요(최대 1,000자)</label>
                                <span>({inputInquire.length}/1000)</span>
                            </div>
                            <textarea name="" id="etc" maxLength={1000} className='body3 medium' placeholder='내용 입력' onChange={handelInquireContent}></textarea>
                        </div>
                        <div className={`${styles.agree_box} mgt40`}>
                            <div className={styles.agree}>
                                <input className={styles.check} type="checkbox" id="check" checked={checkAgree} onChange={()=>setCheckAgree(!checkAgree)} />
                                <label htmlFor="check" />
                                <div className={`body3 medium gs10`}>개인정보 수집 및 이용 안내 동의</div>
                            </div>
                            <div onClick={agreeInfoModal.onClickToggleModal} className={'body3 extrabold sub7'}>상세보기</div>
                        </div>
                        <div onClick={submit} className={`${styles.inquire_botton} mgt16`}>
                            <div  className='body2 medium wh'>문의하기</div>
                        </div>
                    </form>
                </div>
            </Content>
            <Footer />
        </div>
        
        
    )
}

export default Inquire
